<ng-container *ngIf="document">
  <h1 style="text-align: center">{{document.title}}</h1>
  <p style="text-align: center">Last Modified > {{document.updated | date}}</p>
  <p>&nbsp;</p>

  <p [innerHTML]="document.text"></p>
</ng-container>

<mat-spinner style="margin: auto" *ngIf="!document"></mat-spinner>
